import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '../../bits/Button.jsx';
import '../../../../stylesheets/components/geofence_editor_action_sheet.scss';

import LowerActionPanel from './LowerActionPanel.jsx';

class GeofenceEditorActionSheet extends Component {
  nextBtnTitle = () => {
    const { geofence } = this.props;
    if (!geofence || geofence.isValid()) {
      return 'Next';
    }
    const pointsLeft = 3 - geofence.numVertices();
    return `Add at least ${pointsLeft} more ${pointsLeft === 1 ? 'point' : 'points'}`;
  }

  render() {
    const {
      open,
      geofence,
      onNext,
      onCancel,
    } = this.props;

    const nextEnabled = geofence ? geofence.isValid() : false;

    return (
      <LowerActionPanel open={open} onClose={onCancel}>
        <h1 className="panel-title">Geofence editor</h1>
        <p>Tap the map to create or edit a geofence</p>
        <div className="geofence_actionsheet_actions">
          <Button
            onClick={onNext}
            color="primary"
            disabled={!nextEnabled}
            nooverflow>{this.nextBtnTitle()}</Button>
        </div>
      </LowerActionPanel>
    );
  }
}

GeofenceEditorActionSheet.propTypes = {
  open: PropTypes.bool,
  geofence: PropTypes.object,
  onCancel: PropTypes.func,
  onNext: PropTypes.func,
};

export default GeofenceEditorActionSheet;
